/**
 * Daily Times
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.custom.times');

goog.require('yext.localization');
goog.require('yext.location.hours');
goog.require('yext.time');

goog.scope(function() {
  var _times = yext.location.custom.times;

  /**
   * Time model base class. Used with DailyTime and HolidayDailyTime
   *
   * TODO(mattjs) Use this base class with Hours and HolidayHours
   *
   * @constructor
   * @param {!Object} data Time model properties for initialization
   */
  function Time(data) {
    data = typeof data === 'object' ? data : {};
    $.extend(this, data);
  }

  // Export this class
  _times.Time = Time;

  Time.prototype.namespace = 'time';

  /**
  * Remove the event handlers
  */
  Time.prototype.destroy = function() {
    $(this).off('.' + this.namespace);
  };

  /**
   * Return properties of the object
   *
   * @return {!Object} Properties of the class
   */
  Time.prototype.ownProperties = function() {
    var properties = {};
    for (var prop in this) {
      if (this.hasOwnProperty(prop)) {
        properties[prop] = this[prop];
      }
    }
    return properties;
  };

  /**
   * Filter an object to include only changed properties
   *
   * @param {!Object} data Update to model
   * @return {!Object} Object of changes to the model
   */
  Time.prototype.getChanges = function(data) {
    var changed = false;
    var changes = {};

    if (this.validProperties) {
      data = this.cleanUp(data);
    }

    for (var prop in data) {
      if (data[prop] !== this[prop]) {
        changed = true;
        changes[prop] = data[prop];
      }
    }
    return changed ? changes : false;
  };

  /**
   * Clean an object to only contain validProperties
   *
   * @param {!Object} data Data in
   * @return {!Object} Clean data out
   */
  Time.prototype.cleanUp = function(data) {
    var clean = {};
    for (var property in data) {
      if (this.validProperties.indexOf(property) != -1) {
        clean[property] = data[property];
      }
    }
    return clean;
  };

  /**
   * Broadcast that an update has been made
   *
   * @param {!Object} update Details about which properties have been updated
   */
  Time.prototype.broadcast = function(update) {
    $(this).trigger('updated.' + this.namespace, update);
  };

  /**
   * Time UI base class
   *
   * Used with DailyTimeUI and HolidayDailyTimeUI
   *
   * TODO(mattjs) Implement this class in Hours and HolidayHours
   *
   * @constructor
   * @param {!Object} model The model related to the UI
   * @param {!jQuery} $element The DOM element
   */
  function TimeUI(model, $element) {
    this.model = model;
    this.setupElement($element);
    this.initialize();
  }

  // Export this class
  _times.TimeUI = TimeUI;

  /**
   * Setup the context (outermost UI element) used to find any important nested
   * UI elements
   *
   * If you provide a context, modelFromElements will be called which will
   * extract model details from the DOM. Otherwise the model was provided and
   * the template should be cloned and then the values from the model rendered
   *
   * @param {!jQuery} $element The outermost UI element
   */
  TimeUI.prototype.setupElement = function($element) {
    if ($element) {
      this.$element = $element;
      this.getElements();
      this.modelFromElements();
    } else {
      this.$element = this.cloneTemplate();
      this.getElements();
      this.render();
    }
  };

  /**
   * Initialize is the last method called by the constructor. Override this
   * method if anything other than dataBindings is needed on
   */
  TimeUI.prototype.initialize = function() {
    this.dataBindings();
  };

  /**
   * Stubbed methods for TimeUI (to be overridden)
   */
  TimeUI.prototype.getElements = function() {};
  TimeUI.prototype.dataBindings = function() {};
  TimeUI.prototype.cloneTemplate = function() {};
  TimeUI.prototype.modelFromElements = function() {};

  /**
   * Broadcast a message with some optional data
   *
   * @param {string} message Message type/name
   * @param {!Object} data Some data to be sent with the message
   */
  TimeUI.prototype.broadcast = function(message, data) {
    $(this).trigger(message, data);
  };

  /**
   * Cleanup to avoid memory leaks
   */
  TimeUI.prototype.destroy = function() {
    this.model.destroy();
    this.$element.remove();
    $(this).off();
  };

  /**
   * Format the time
   *
   * If the time less or equal to 12 and does not have a meridium, slap an AM on it
   *
   * @param {string} time Time as string
   * @return {string} Time as string, maybe with an AM
   */
  _times.formatTime = function(time) {
    if (yext.localization.isUSLocale()
        && time
        && parseInt(time, 10) <= 12
        && !yext.time.containsMeridium(time)) {
      return time + ' AM';
    }
    return time;
  };

  /**
   * Build a simple table
   *
   * @param {!Array} table Array of row objects with label and value
   * @return {!jQuery}
   */
  _times.buildTimesTable = function(table) {
    var $table = yext.location.hours.generateHoursTable();
    var $tr = $('<tr/>');
    var $td = $('<td/>');

    table.forEach(function(row) {
      $table.append(
        $tr.clone().attr('tid', 'daily-time-display')
          .append($td.clone().addClass('hours-day sl-day').html(row.label))
          .append($td.clone().addClass('sl-time').html(row.value)));
    });

    return $table;
  };

  /**
   * Find holiday times by fieldName
   *
   * @param {string} fieldName Field name from which to search holiday daily times
   * @return {!jQuery} The holiday daily times field
   */
  _times.findHolidayDailyTimes = function(fieldName) {
    var holidayDailyTimesFieldName = fieldName;
    if (fieldName && fieldName.startsWith('virtual')) {
      holidayDailyTimesFieldName = fieldName.replace('.times', '.holidaytimes');
    }
    return $('.js-holiday-times-field input[name=field][value="' + holidayDailyTimesFieldName + '"]').closest('.js-holiday-times-field');
  };
});
